import React from "react";
import { useAtomValue } from "jotai";
import { enlargeAvatarData } from "../../atoms/avatar";
import EnlargedUserAvatar from "./EnlargedUserAvatar";
import RootOverlayHost from "../RootOverlayHost";

const UserAvatarPortal = () => {
    const enlargeAvatarAtom = useAtomValue(enlargeAvatarData);

    if (!enlargeAvatarAtom) {
        return null;
    }

    // The enlarged avatar is a full-screen blocking overlay (tap anywhere closes), so it lifts above
    // native modals on iOS via the host. Android/web are unchanged (passthrough).
    return (
        <RootOverlayHost pointerMode="blocking">
            <EnlargedUserAvatar {...enlargeAvatarAtom} />
        </RootOverlayHost>
    );
};

export default UserAvatarPortal;
